export const TABLE_HEADERS = [
    "id",
    "Date",
    "Week",
    "Developers",
    "Project names",
    "",
    "",
];
